import DevicePermissions from 'Elements/Modals/DevicePermissions';
import DeviceSettings from 'Elements/Modals/DeviceSettings';
import MeetingFeedback from 'Elements/Modals/MeetingFeedback';
import MeetingProtector from 'Elements/Modals/MeetingProtector';
import TsAndCs from 'Elements/Modals/TsAndCs';

export const modalTypes = {
  CUSTOM: 'custom',
  DEFAULT: 'default',
};

export default {
  devicePermissions: DevicePermissions,
  deviceSettings: DeviceSettings,
  meetingFeedback: MeetingFeedback,
  meetingProtector: MeetingProtector,
  tsAndCs: TsAndCs,
};
